import {
    GET_GCP_REFRESH,
    GET_GCP_REFRESH_FAIL,
    GET_GCP_REFRESH_SUCCESS,
    GET_GCP_NOTIFICATION_CHANNELS,
    GET_GCP_NOTIFICATION_CHANNELS_FAIL,
    GET_GCP_NOTIFICATION_CHANNELS_SUCCESS,
    POST_GCP_CREATE_RESOURCE_ALERTS,
    POST_GCP_CREATE_RESOURCE_ALERTS_FAIL,
    POST_GCP_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_GCP_RESOURCE_SERVICE_MAPPING,
    POST_GCP_RESOURCE_SERVICE_MAPPING_FAIL,
    POST_GCP_RESOURCE_SERVICE_MAPPING_SUCCESS,
    POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    GET_GCP_ALL_RESOURCE_ALERTS_PAGE,
    GET_GCP_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_GCP_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_ALL_ORG_GCP_RESOURCE_TYPES,
    GET_ALL_ORG_GCP_RESOURCE_TYPES_FAIL,
    GET_ALL_ORG_GCP_RESOURCE_TYPES_SUCCESS,
    GET_GCP_CLOUD_RESOURCES,
    GET_GCP_CLOUD_RESOURCES_FAIL,
    GET_GCP_CLOUD_RESOURCES_SUCCESS,
    GET_GCP_ALL_RESOURCE_COUNT,
    GET_GCP_ALL_RESOURCE_COUNT_FAIL,
    GET_GCP_ALL_RESOURCE_COUNT_SUCCESS,
    GET_USER_RESCAN_STATUS_GCP_SUCCESS,
    GET_USER_RESCAN_STATUS_GCP_FAIL,
    GET_USER_RESCAN_STATUS_GCP,
} from "./actionTypes";

export const getGcpRefresh = () => ({
    type: GET_GCP_REFRESH,
})

export const getGcpRefreshSuccess = gcp_refresh => ({
    type: GET_GCP_REFRESH_SUCCESS,
    payload: gcp_refresh,
})

export const getGcpRefreshFail = error => ({
    type: GET_GCP_REFRESH_FAIL,
    payload: error,
})

export const getGCPNotificationChannels = () => ({
    type: GET_GCP_NOTIFICATION_CHANNELS,
})

export const getGCPNotificationChannelsSuccess = notification_channels => ({
    type: GET_GCP_NOTIFICATION_CHANNELS_SUCCESS,
    payload: notification_channels,
})

export const getGCPNotificationChannelsFail = error => ({
    type: GET_GCP_NOTIFICATION_CHANNELS_FAIL,
    payload: error,
})

export const postGCPCreateResourceAlerts = (data) => ({
    type: POST_GCP_CREATE_RESOURCE_ALERTS,
    payload: { data }
})

export const postGCPCreateResourceAlertsSuccess = (alerts) => ({
    type: POST_GCP_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: alerts
})

export const postGCPCreateResourceAlertsFail = error => ({
    type: POST_GCP_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error,
})

export const postGCPResourceOpsGenieTeamMapping = (data) => ({
    type: POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: { data }
})

export const postGCPResourceOpsGenieTeamMappingSuccess = gcp_cloudResources => ({
    type: POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    payload: gcp_cloudResources,
})

export const postGCPResourceOpsGenieTeamMappingFail = error => ({
    type: POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    payload: error,
})

export const postGCPResourceServiceMapping = data => ({
    type: POST_GCP_RESOURCE_SERVICE_MAPPING,
    payload: { data }
})

export const postGCPResourceServiceMappingSuccess = gcp_cloudResources => ({
    type: POST_GCP_RESOURCE_SERVICE_MAPPING_SUCCESS,
    payload: gcp_cloudResources,
})

export const postGCPResourceServiceMappingFail = error => ({
    type: POST_GCP_RESOURCE_SERVICE_MAPPING_FAIL,
    payload: error,
})

export const postGCPResourcePagerdutyServiceMapping = data => ({
    type: POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    payload: { data }
})

export const postGCPResourcePagerdutyServiceMappingSuccess = gcp_cloudResources => ({
    type: POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    payload: gcp_cloudResources,
})

export const postGCPResourcePagerdutyServiceMappingFail = error => ({
    type: POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    payload: error,
})

export const getGCPAllResourceAlertsPage = (page_filters) => ({
    type: GET_GCP_ALL_RESOURCE_ALERTS_PAGE,
    payload: { page_filters }
})

export const getGCPAllResourceAlertsPageSuccess = gcp_all_resource_alerts => ({
    type: GET_GCP_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: gcp_all_resource_alerts,
})

export const getGCPAllResourceAlertsPageFail = error => ({
    type: GET_GCP_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error,
})

export const getGCPResourceCount = (page_filters) => ({
    type: GET_GCP_ALL_RESOURCE_COUNT,
    payload: { page_filters }
})

export const getGCPResourceCountSuccess = gcp_all_resource_count => ({
    type: GET_GCP_ALL_RESOURCE_COUNT_SUCCESS,
    payload: gcp_all_resource_count,
})

export const getGCPResourceCountFail = error => ({
    type: GET_GCP_ALL_RESOURCE_COUNT_FAIL,
    payload: error,
})

export const getAllOrgGCPResourceTypes = () => ({
    type: GET_ALL_ORG_GCP_RESOURCE_TYPES
})

export const getAllOrgGCPResourceTypesSuccess = orgGCPResourceTypes => ({
    type: GET_ALL_ORG_GCP_RESOURCE_TYPES_SUCCESS,
    payload: orgGCPResourceTypes,
})

export const getAllOrgGCPResourceTypesFail = error => ({
    type: GET_ALL_ORG_GCP_RESOURCE_TYPES_FAIL,
    payload: error,
})

export const getGCPCloudResources = (data) => {
    return {
        type: GET_GCP_CLOUD_RESOURCES,
        payload: data
    }
}

export const getGCPCloudResourcesSuccess = gcp_cloudResources => ({
    type: GET_GCP_CLOUD_RESOURCES_SUCCESS,
    payload: gcp_cloudResources,
})

export const getGCPCloudResourcesFail = error => ({
    type: GET_GCP_CLOUD_RESOURCES_FAIL,
    payload: error,
})


export const getGCPRefreshScanStatus = () => ({
    type: GET_USER_RESCAN_STATUS_GCP,
})

export const getGCPRefreshScanStatusSuccess = gcp_refresh_status => ({
    type: GET_USER_RESCAN_STATUS_GCP_SUCCESS,
    payload: gcp_refresh_status,
})

export const getGCPRefreshScanStatusFail = error => ({
    type: GET_USER_RESCAN_STATUS_GCP_FAIL,
    payload: error,
})
